export const rawColors = {
    white: '#fff',
    black: '#000',
    cyan: {
        100: '#DDF6FE',
        200: '#BCEDFD',
        300: '#88E5FB',
        400: '#1FD5F9',
        500: '#07B6DA',
        600: '#15889F',
        700: '#116172',
        800: '#012A32',
        900: '#051518',
    },
    // light mode
    'gray-light': {
        100: '#FDFDFC',
        200: '#EFEFEC',
        300: '#E2E2DF',
        400: '#DBDBD8',
        500: '#BDBDBB',
        600: '#707070',
        700: '#636363',
        800: '#4D4D4D',
        900: '#3B3B3B',
    },
    // dark mode
    'gray-dark': {
        100: '#CCCCCC',
        200: '#B2B2B2',
        300: '#999999',
        400: '#666666',
        500: '#30302F',
        600: '#202020',
        700: '#1F1F1F',
        800: '#131313',
        900: '#070707',
    },
    purple: {
        100: '#F2E4FB',
        200: '#EABFFD',
        300: '#DC85FF',
        400: '#BA1FF9',
        500: '#9A1ACE',
        600: '#7A15A2',
        700: '#591077',
        800: '#390B4B',
        900: '#190620',
    },
    orange: {
        100: '#FEE1CD',
        200: '#FDCAA5',
        300: '#FCAF78',
        400: '#FA954C',
        500: '#F97A1F',
        600: '#DB5E06',
        700: '#A44704',
        800: '#6D2F03',
        900: '#321501',
    },
    green: {
        100: '#D1FADF',
        200: '#B8EFD1',
        300: '#23DE6B',
        400: '#1EB66A',
        500: '#009E4F',
        600: '#00753B',
        700: '#006430',
        800: '#003213',
        900: '#001905',
    },
    red: {
        100: '#FAE6E6',
        200: '#FFCDC7',
        300: '#FFA9A0',
        400: '#FF7566',
        500: '#FA4C39',
        600: '#B32909',
        700: '#791B11',
        800: '#421510',
        900: '#1F0E0B',
    },
    amber: {
        100: '#FAEDD1',
        200: '#FBDFB1',
        300: '#FFB752',
        400: '#FFA424',
        500: '#EF8B01',
        600: '#9D4D06',
        700: '#833E01',
        800: '#3F2208',
        900: '#1A0E04',
    },
    yellow: {
        100: '#FCF7E0',
        200: '#FDF6A5',
        300: '#FCF178',
        400: '#FAEC4C',
        500: '#F9E71F',
        600: '#DBC906',
        700: '#A49704',
        800: '#6D6503',
        900: '#1F1005',
    },
    blue: {
        100: '#E2EBFD',
        200: '#CADBFC',
        300: '#6E9DFE',
        400: '#395CF9',
        500: '#002CF2',
        600: '#0A259F',
        700: '#0F1F66',
        800: '#0C1640',
        900: '#090C17',
    },
    lime: {
        100: '#E5FECD',
        200: '#D1FDA5',
        300: '#BAFC78',
        400: '#A3FA4C',
        500: '#8CF91F',
        600: '#70DB06',
        700: '#54A404',
        800: '#386D03',
        900: '#1A3201',
    },
    teal: {
        100: '#CDFEF6',
        200: '#A5FDEE',
        300: '#79FCE6',
        400: '#4CFADD',
        500: '#1FF9D5',
        600: '#06DBB7',
        700: '#04A489',
        800: '#036D5C',
        900: '#01322A',
    },
    indigo: {
        100: '#CDD5FE',
        200: '#A5B4FD',
        300: '#788EFC',
        400: '#4C69FA',
        500: '#1F44F9',
        600: '#0629DB',
        700: '#041FA4',
        800: '#03156D',
        900: '#010932',
    },
    violet: {
        100: '#FECDFE',
        200: '#FDA5FD',
        300: '#FC78FC',
        400: '#FA4CFA',
        500: '#F91FF9',
        600: '#DB06DB',
        700: '#A404A4',
        800: '#6D036D',
        900: '#320132',
    },
    pink: {
        100: '#FECDE5',
        200: '#FDA5D1',
        300: '#FC78BA',
        400: '#FA4CA3',
        500: '#F91F8C',
        600: '#DB0670',
        700: '#A40454',
        800: '#6D0338',
        900: '#32011A',
    },
};
